import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { PaymentMethod } from './paymentMethod';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(private api: GatewayAPIService) {}

  deletePaymentMethod(paymentMethodId: string): Promise<void> {
    return this.api.apiCallSane(
      '/terminal/payment-method',
      'DELETE',
      this.api.getDefaultHeaders(),
      { paymentMethodId: paymentMethodId },
      null,
      this.options,
    );
  }

  getTokenizationFormURL(
    customerId: string,
    merchantId: string,
  ): Promise<string> {
    return this.api
      .apiCallSane(
        '/customer/tokenize-form',
        'GET',
        this.api.getDefaultHeaders(),
        {
          customerId: customerId,
          merchantId: merchantId,
        },
        null,
        this.options,
      )
      .then((response) => response.iframeURI);
  }

  getPaymentMethodsByCustomerId(customerId: string): Promise<PaymentMethod[]> {
    return this.api
      .apiCallSane(
        '/terminal/payment-methods',
        'GET',
        this.api.getDefaultHeaders(),
        { customerId: customerId },
        null,
        this.options,
      )
      .then((response: { paymentMethods: Partial<PaymentMethod>[] }) =>
        response.paymentMethods.map((s) => new PaymentMethod(s)),
      );
  }

  getPaymentMethod(
    paymentMethodId: string,
    customerId: string,
  ): Promise<PaymentMethod> {
    return this.api.apiCallSane(
      '/terminal/payment-method',
      'GET',
      this.api.getDefaultHeaders(),
      {
        paymentMethodId: paymentMethodId,
        customerId: customerId,
      },
      null,
      this.options,
    );

    //let pms = [];
    /*
        pms.push(new PaymentMethod("13579", "12345", "Mastercard", "MC ****6543", "12/25", "6543"));
        pms.push(new PaymentMethod("6435", "12345", "Visa", "Visa ****4732", "3/24", "4732"));
        pms.push(new PaymentMethod("13578", "12345", "Mastercard", "MC ****2364", "11/25", "2364"));
        pms.push(new PaymentMethod("52434", "12345", "Mastercard", "MC ****7354", "5/24", "7354"));
        pms.push(new PaymentMethod("51234", "12345", "American Express", "Amex ****9872", "7/25", "9872"));
        pms.push(new PaymentMethod("75444", "12345", "Visa", "Visa ****2343", "3/24", "2343"));
        pms.push(new PaymentMethod("74534", "12345", "Visa", "Visa ****1234", "12/25", "1234"));
        pms.push(new PaymentMethod("12987", "12345", "Visa", "Visa ****7645", "5/25", "7645"));

        for (var i=0; i<pms.length; i++) {
            if (pms[i].id == id) {
                return pms[i];
            }
        }

        throw new Error("No payment method found.");
        //return new PaymentMethod("3jk345h234", "y6tj32olik234", "Visa ****1239", "08/23", "1239");
        */

    //return PaymentMethod.createEmpty();
  }
}
